import React from 'react'
import { Box, Container, useMediaQuery } from '@mui/material';
import { useTheme } from '@emotion/react';
import { useSettingsContext } from '../../setting/SettingsContext';

const WrapperSection = ({ link, children, sx }) => {
  const themeM = useTheme();
  const isMobile = useMediaQuery(themeM.breakpoints.down('sm'));
  // When themeStretch is true, drop the xl max-width so the content fills
  // the viewport width. Useful on wide screens / data-dense pages.
  const { themeStretch } = useSettingsContext();
  return (
    <>
      <div id={link}>
        <Container maxWidth={themeStretch ? false : 'xl'}>
          <Box sx={{ my: { md: 2 ,xs:1}, display: 'flex', flexDirection: 'column', gap: { md: 1.7, xs: 1 }, position: 'relative', zIndex: 11, textAlign: isMobile && 'center', ...sx }} >
            {children}
          </Box>
        </Container>
      </div>
    </>
  )
}

export default WrapperSection